export default __webpack_public_path__ + "static/media/pym.6826ee46.svg";